import { render, staticRenderFns } from "./mobile_videoTutorial.vue?vue&type=template&id=20efc37a&scoped=true"
import script from "./mobile_videoTutorial.vue?vue&type=script&lang=js"
export * from "./mobile_videoTutorial.vue?vue&type=script&lang=js"
import style0 from "./mobile_videoTutorial.vue?vue&type=style&index=0&id=20efc37a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20efc37a",
  null
  
)

export default component.exports